export type SaleTaskTemplate = {
    id: number,
    name: string,
    description: string
}

export const DefaultSaleTaskTemplate: SaleTaskTemplate = {
    id: 0,
    name: '',
    description: ''
}

export type SaleTaskTemplateIndex = {
    [templateId: number]: SaleTaskTemplate
}

export type SaleTaskTemplateItem = {
    id: number,
    saleTaskTemplateId: number,
    taskName: string,
    taskDescription: string,
    priority: number,
    daysBetweenNotifications: number,
    startOffsetDays: number,
    endOffsetDays: number
}

export const DefaultSaleTaskTemplateItem = (saleTaskTemplateId: number): SaleTaskTemplateItem => ({
    id: 0,
    saleTaskTemplateId,
    taskName: '',
    taskDescription: '',
    priority: 3,
    daysBetweenNotifications: 0,
    startOffsetDays: 0,
    endOffsetDays: 0
})

export type SaleTaskTemplateItemIndex = {
    [itemId: number]: SaleTaskTemplateItem
}

// The dialog's working form state: items are edited locally (add/edit/remove all just mutate this
// array) and nothing hits the server until the whole thing - template plus every item change - is
// submitted together in one action. deletedItemIds tracks items that existed on the server
// (non-zero id) but were removed locally, since they won't show up missing from `items` otherwise.
export type TaskTemplateFormData = {
    template: SaleTaskTemplate,
    items: SaleTaskTemplateItem[],
    deletedItemIds: number[]
}
